export default __webpack_public_path__ + "static/media/img10.e7d7c223.png";